export enum TSegmentationAction {
  edit = "edit",
  paint = "paint",
}

export enum OtherTools {
  layers = "layers",
}
